module.exports = __webpack_public_path__ + "img/bdesc.9864efb9.png";